import { SeeqNames } from '@/main/app.constants.seeqnames';
import { headlessRenderCategory } from '@/services/headlessCapture.utilities';
import { headlessRenderMode } from '@/hybrid/utilities/utilities';
import { SeeqAxiosRequestConfig } from '@/hybrid/requests/axios.utilities';
import { getOriginLabel, getOriginUrl } from '@/hybrid/utilities/http.utilities';

export function requestOriginInterceptor(config: SeeqAxiosRequestConfig) {
  if (config.headers) {
    config.headers[SeeqNames.API.Headers.RequestOrigin] = headlessRenderMode()
      ? headlessRenderCategory() ?? ''
      : 'Analysis';
    config.headers[SeeqNames.API.Headers.RequestOriginURL] = getOriginUrl();
    config.headers[SeeqNames.API.Headers.RequestOriginLabel] = getOriginLabel();
  }
  return config;
}
